export default "__VITE_ASSET__DtJZX6QI__"